import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  Steps,
  Divider,
  Row,
  Col,
  Result,
  Modal,
  Tooltip,
  Collapse,
  Button,
} from "antd";

import WithDrawThirdStep from "./withdraw/WithDrawThirdStep";
import WithDrawFirstStep from "./withdraw/WithDrawFirstStep";
import WithDrawSecondStep from "./withdraw/WithDrawSecondStep";
import { post, get } from "../../../helper/request";
import { Link } from "react-router-dom";
import BoxFAQ from "../../../components/boxfaq/BoxFAQ";
import PaymentSlip from "../../../components/paymentslip/PaymentSlip";
import { CheckCerrency } from "../../../components/checkcurrency";
import OpenAccount from "../../../components/open-account/OpenAccount";
import { CheckPhoneCode } from "../../../components/check-phonecode";
import PhoneDialog from "../../setting/dialog";
import { renderApiDomain } from "../../../helper/renderApiDomain";
const { Panel } = Collapse;
const locale = require("react-redux-i18n").I18n;
const customPanelStyle = {
  background: "#FFF",
  borderRadius: 4,
  fontSize: 12,
  // marginBottom: 24,
  border: 0,
  overflow: "hidden",
};
// const locale = require("react-redux-i18n").I18n;
export const WithDraw = (props) => {
  const { user } = props;
  const [step, setStep] = useState(null);
  const [account, setAccount] = useState(undefined);
  const [amount, setAmount] = useState(3);
  const [amount_thb, setAmount_thb] = useState(0);
  const [paymentAll, setPaymentAll] = useState([]);
  const [account_withdraw_id, setAccount_withdraw_id] = useState(0);
  const [accountSelected, setAccountSelected] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [payment_id, setPayment_id] = useState(1);
  const [payment_key, setPayment_key] = useState("thai_bank");
  const [address, setAddress] = useState("");
  const [message, setMessage] = useState({ title: "", description: "" });
  const [currentRate, setCurrentRate] = useState(0);
  const [paymentSelected, setpaymentSelected] = useState(null);
  const [accountWelcome, setaccountWelcome] = useState(null);
  const [walletAddress, setWalletAddress] = useState("");
  const [isModalVisible, setIsModalVisible] = useState({
    phone: false,
    bank: false,
  });
  const [prefixPhone, setPrefixPhone] = useState(undefined);
  const [cryptoRate, setCryptoRate] = useState(0);
  const [cryptoFee, setCryptoFee] = useState(0);
  const [dataCrypto, setDataCrypto] = useState(null);
  const [cryptoSelected, setCryptoSelected] = useState(null);
  const profile = user.profile;
  useEffect(() => {
    const country = profile?.country_id;
    if (country > 0) {
      setPrefixPhone(user?.profileCountry?.prefix_phone);
    }
  }, [profile]);

  const onBackStep = (acc) => {
    setStep(step - 1);
    if (acc !== "welcome") {
      setAmount(0);
    }
    if (step === 1) {
      setAccountSelected(null);
      setpaymentSelected(null);
      setPayment_key(null);
      setPayment_id(null);
    }
  };

  const setOnCurrentRate = (value) => {
    setCurrentRate(value);
  };
  const onNextStep = (withDrawid) => {
    if (
      paymentSelected.payment_key === "gcash_payout" ||
      paymentSelected.payment_key === "limepay_mobile_money_payout" ||
      paymentSelected.payment_key === "gate_mobile_money_payout" ||
      paymentSelected.payment_key === "maya_payout"
    ) {
      if (profile.phone_number === null) {
        setIsModalVisible({ bank: false, phone: true });
      } else {
        setAccount_withdraw_id(withDrawid);
        setStep(step + 1);
      }
    } else {
      setAccount_withdraw_id(withDrawid);
      setStep(step + 1);
    }
  };
  const onNextStepPayment = (state) => {
    setStep(step + 1);
  };
  const onSuccess = (state) => {
    addInvite();
    setShowSuccess(true);

    setStep(step + 1);
  };
  const addInvite = () => {
    try {
      const customerInvitation = {
        customerEmail: user?.profile?.email,
        customerFirstName: user?.profile?.first_name,
        customerLastName: user?.profile?.last_name || "",
      };
      window.tfn.createInvitation(customerInvitation);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    renderWithdraw();
  }, []);

  const renderWithdraw = () => {
    let urlParams = new URLSearchParams(window.location.search);
    let account_number = urlParams.get("account");
    let condition = urlParams.get("condition");
    let isamount = urlParams.get("amount");
    if (account_number && condition) {
      setAccountSelected(
        props.user.accounts.find((e) => e.account_number === account_number)
      );

      setaccountWelcome({
        account: props.user.accounts.find(
          (e) => e.account_number === account_number
        ),
        condition: condition,
        amount: isamount,
      });
      setAmount(isamount);
      setStep(0);
    } else if (account_number) {
      setAccountSelected(
        props.user.accounts.find((e) => e.account_number === account_number)
      );
      setStep(0);
      // setStep({
      //   step: 1,
      //   account: props.accounts.find(
      //     (e) => e.account_number === account_number
      //   ),
      // });
    } else {
      setStep(0);
    }
  };

  const onAccountSelected = (value) => {
    if (props.user.accounts.find((e) => e.id === value)) {
      setAccountSelected(props.user.accounts.find((e) => e.id === value));
    }
  };
  const onPaymentSelected = (event) => {
    if (paymentAll.find((e) => e.payment_key === event.target.value)) {
      setpaymentSelected(
        paymentAll.find((e) => e.payment_key === event.target.value)
      );
      setPayment_key(
        paymentAll.find((e) => e.payment_key === event.target.value).payment_key
      );
      if (event.target.value === "b2binpay" && !accountWelcome) {
        setAmount(10);
      }
    }
  };
  useEffect(() => {
    get(`${renderApiDomain()}payment/withdraw`)
      .then(({ data }) => {
        setPaymentAll(data);
        if (data.length > 0) {
          if (data.filter((e) => e.recommend === 1).length > 0) {
            setpaymentSelected(data.filter((e) => e.recommend === 1)[0]);
            setPayment_key(
              data.filter((e) => e.recommend === 1)[0].payment_key
            );
            setPayment_id(data.filter((e) => e.recommend === 1)[0].id);
          } else {
            setpaymentSelected(data[0]);
            setPayment_key(data[0].payment_key);
            setPayment_id(data[0].id);
          }
        } else {
          setpaymentSelected(null);
          setPayment_key(null);
          setPayment_id(null);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  const onChangeAmount = (value) => {
    setAmount(value);
  };
  const handleCancel = () => {
    setIsModalVisible({
      phone: false,
      bank: false,
    });
  };
  const onChangeWalletAddress = (value) => {
    setWalletAddress(value);
  };
  const onChangeCryptoRate = (value) => {
    setCryptoRate(value);
  };
  const onChangeCryptoFee = (value) => {
    setCryptoFee(value);
  };
  const onChangeDataCrypto = (value) => {
    setDataCrypto(value);
  };
  const onChangeCryptoSeleted = (value) => {
    setCryptoSelected(value);
  };
  const renderStep = (step) => {
    switch (step) {
      case 0:
        return (
          <WithDrawFirstStep
            key={"withdraw step 1"}
            onNextStep={onNextStep}
            onBackStep={onBackStep}
            onAccountSelected={onAccountSelected}
            paymentId={payment_id}
            paymentKey={payment_key}
            paymentAll={paymentAll}
            onChangePayment={onPaymentSelected}
            paymentSelected={paymentSelected}
            accountSelected={accountSelected}
            accountWelcome={accountWelcome}
          />
        );
      case 1:
        return (
          // <Modal
          //   style={{ borderRadius: 20 }}
          //   headStyle={{ textAlign: "center" }}
          //   title="Withdraw"
          //   visible={step === 1}
          //   onOk={handleOk}
          //   onCancel={handleCancel}
          //   width={580}
          //   className="user"
          //   footer={[
          //     <div className="d-flex justify-content-between text-center"></div>,
          //   ]}
          // >
          <WithDrawSecondStep
            key={"withdraw step 2"}
            account={accountSelected}
            onSetRate={setOnCurrentRate}
            onBackStep={onBackStep}
            onNextStep={onNextStep}
            onNextStepPayment={onNextStepPayment}
            paymentId={paymentSelected.id}
            paymentKey={payment_key}
            paymentSelected={paymentSelected}
            address={address}
            onChangeAmount={onChangeAmount}
            amount={amount}
            accountWelcome={accountWelcome}
            onChangeWalletAddress={onChangeWalletAddress}
            onChangeCryptoRate={onChangeCryptoRate}
            onChangeCryptoFee={onChangeCryptoFee}
            onChangeCryptoSeleted={onChangeCryptoSeleted}
          />
          // </Modal>
        );
      case 2:
        return (
          // <Modal
          //   style={{ borderRadius: 20 }}
          //   headStyle={{ textAlign: "center" }}
          //   title="Withdraw"
          //   visible={step === 2}
          //   width={580}
          //   onOk={handleOk}
          //   onCancel={handleCancel}
          //   className="user"
          //   footer={[
          //     <div className="d-flex justify-content-between text-center"></div>,
          //   ]}
          // >
          <WithDrawThirdStep
            amount={amount}
            account={accountSelected}
            account_withdraw_id={account_withdraw_id}
            onNextStep={onNextStep}
            onBackStep={onBackStep}
            onSuccess={onSuccess}
            onNextStepPayment={onNextStepPayment}
            paymentId={paymentSelected.id}
            paymentSelected={paymentSelected}
            paymentKey={payment_key}
            address={address}
            rate={currentRate}
            accountWelcome={accountWelcome}
            walletAddress={walletAddress}
            cryptoFee={cryptoFee}
            cryptoRate={cryptoRate}
            cryptoSelected={cryptoSelected}
          />
          // </Modal>
        );
      default: {
        if (showSuccess) {
          return (
            <div>
              <div className="d-flex justify-content-center">
                <img
                  src="/assets/images/icons/icon-success.svg"
                  alt="success"
                />
              </div>
              <div className="text-center fs-14 font-weight-bold mt-4">
                {locale.t("withdraw_success.title")}
              </div>
              <div className="text-center fs-18 font-weight-bold mt-4 text-primary-new-iux">
                {amount}{" "}
                {accountSelected?.account_type === "Cent" ? "USC" : "USD"}
              </div>
              <div className="text-center fs-14 font-weight-bold mt-4 mb-4">
                {locale.t("withdraw_success.detail")}
              </div>

              <Link to={`/${localStorage.getItem("locale")}/wallet`}>
                <Button className="btn-primary-new-iux w-100">
                  {locale.t("withdraw_success.button")}
                </Button>
              </Link>
            </div>
          );
        }
      }
    }
  };
  const verifyFrom = false;
  const numberPhone = undefined;
  return (
    <div className="px-2 pb-2 px-sm-4 pb-sm-2">
      <div className="row ">
        <div className="col-12 col-lg-8 ">
          <div style={{ maxWidth: "100%" }}>
            {props?.user?.accounts?.filter((e) => e.type === "real").length >
              0 || accountWelcome ? (
              renderStep(step)
            ) : (
              <OpenAccount />
            )}
          </div>
        </div>
        <div className="d-none d-md-block col-0 col-lg-4 user">
          <BoxFAQ step={step} type={"withdraw"} />
        </div>
        <PhoneDialog
          title={"Secure Your Withdrawals"}
          deatil={"To withdraw securely, please verify your phone number."}
          verifyFrom={verifyFrom}
          numberPhone={numberPhone}
          profile={profile}
          prefixPhone={prefixPhone}
          locale={locale}
          isModalVisible={isModalVisible}
          handleCancel={handleCancel}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => state;

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(WithDraw);
